// Names from the data (issuers, suppliers, employees) that the French UI translation must leave alone.
// The translation also replaces single words inside texts, which turned the supplier "GC-Gruppe" into "GC-Groupe".
const texts = new Set<string>();

/** Remembers names shown as whole text nodes; empty values are ignored. */
export function keepTexts(values: Iterable<string | null | undefined>) {
  for (const v of values) { const t = v?.trim(); if (t) texts.add(t); }
}
/** True for a text node that is exactly a remembered name. */
export const isDataText = (text: string) => texts.has(text.trim());
